import { render, staticRenderFns } from "./EnacAtplDashboardRegistrationsTable.vue?vue&type=template&id=c395e932"
import script from "./EnacAtplDashboardRegistrationsTable.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardRegistrationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports